"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _classnames = _interopRequireDefault(require("classnames"));
var _TimeSlot = _interopRequireDefault(require("./TimeSlot"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TimeSection = {
  MORNING: 'Morning',
  AFTERNOON: 'Afternoon',
  EVENING: 'Evening'
};
var TimeSelector = function TimeSelector(_ref) {
  var slots = _ref.slots,
    onSelect = _ref.onSelect,
    value = _ref.value,
    markManagedAvailability = _ref.markManagedAvailability;
  var sortedSlots = (0, _lodash.sortBy)(slots, function (_ref2) {
    var start = _ref2.start;
    return start.format('HH:mm');
  });
  var slotsBySection = (0, _lodash.groupBy)(sortedSlots, function (_ref3) {
    var start = _ref3.start;
    if (start.hours() < 12) {
      return TimeSection.MORNING;
    }
    if (start.hours() >= 12 && start.hours() < 16) {
      return TimeSection.AFTERNOON;
    }
    if (start.hours() >= 16) {
      return TimeSection.EVENING;
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "p-[24px] flex flex-col gap-y-[24px]"
  }, slots.length ? [TimeSection.MORNING, TimeSection.AFTERNOON, TimeSection.EVENING].map(function (section, index) {
    var sectionSlots = slotsBySection[section];
    return sectionSlots ? /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "tw-label-medium text-grey-60 mb-[12px]"
    }, section), /*#__PURE__*/_react.default.createElement("div", {
      className: "grid gap-[24px] grid-cols-time-selector"
    }, sectionSlots.map(function (_ref4) {
      var start = _ref4.start,
        _ref4$isFromManagedAv = _ref4.isFromManagedAvailability,
        isFromManagedAvailability = _ref4$isFromManagedAv === void 0 ? true : _ref4$isFromManagedAv;
      return /*#__PURE__*/_react.default.createElement(_TimeSlot.default, {
        key: start.toISOString(),
        value: start,
        isSelected: start.isSame(value),
        onSelect: onSelect,
        className: (0, _classnames.default)({
          'opacity-50': markManagedAvailability && !isFromManagedAvailability
        })
      });
    }))) : null;
  }) : /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-regular text-grey-45"
  }, "There are no available appointment times for this date. Please choose another date to see more times."));
};
var _default = TimeSelector;
exports.default = _default;